import React from 'react';
import ReactDOM from 'react-dom';

import Edoo from './components/views/Edoo';

ReactDOM.render(
  <React.StrictMode>
    <Edoo path={window.location.pathname} />
  </React.StrictMode>,
  document.getElementById('edoo2'),
);
